import { createAuthClient } from "better-auth/react";
import { convexClient } from "@convex-dev/better-auth/client/plugins";
import { emailOTPClient, passkeyClient } from "better-auth/client/plugins";

export const authClient = createAuthClient({
	baseURL: typeof window !== "undefined" ? window.location.origin : "http://localhost:3001",
	plugins: [
		convexClient(),
		emailOTPClient(),
		passkeyClient(),
	],
});
